import { BaseService, type ResponseMessage, type SearchRequest } from "@kiddocare-platform/portal-common/base";
import type { Instance, QuestionAnswer } from "@kiddocare-platform/portal-common/hub";
import type { QuestionDto } from "../components/hub-instance-entity.component";

export class HubExecutionService extends BaseService {

  public Search = async (query: SearchRequest): Promise<ResponseMessage<Array<Instance>>> => {
    try {
      const response = await this.AxiosInstance.post('parent/execution/instances/search', query);
      return response.data;
    } catch (error: any) {
      this.log.error("Search", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public Health = async (): Promise<ResponseMessage<string>> => {
    try {
      const response = await this.AxiosInstance.get('/parent/execution/instances/aiMode/health');
      return response.data;
    } catch (error: any) {
      this.log.error("Health", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async GetByTicket(ticket: string): Promise<ResponseMessage<Instance>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/execution/instances/getByTicket/${ticket}`);
      return response.data;
    } catch (error: any) {
      this.log.error("GetByTicket", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public CreateInstance = async (data: {
    idAccountPatient: bigint;
    idAccountPediatrician: bigint;
    idSelectedProblem: bigint;
    text?: string;
    symptoms: Array<{ idSymptom: bigint }>;
    answers: Array<QuestionAnswer>;
  }): Promise<ResponseMessage<{ instance: Instance }>> => {
    try {
      const response = await this.AxiosInstance.post(`/parent/execution/instances/defaultMode/createInstance`, data);
      return response.data;
    } catch (error: any) {
      this.log.error("CreateInstance", error.stack, JSON.stringify(error));
      throw error;
    }
  };

  public StartTriageAi = async (request: {
    idAccountPatient: bigint;
    idAccountPediatrician: bigint;
    text?: string;
    symptoms?: Array<bigint>;
    idSelectedProblem?: bigint;
  }): Promise<ResponseMessage<QuestionDto>> => {
    try {
      const response = await this.AxiosInstance.post('/parent/execution/instances/aiMode/startTriageAi', request);
      return response.data;
    } catch (error: any) {
      this.log.error("StartTriageAi", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public NextQuestionAi = async (request: {
    codeQuestion: string;
    idSession: string;
    answer: string;
  }): Promise<ResponseMessage<QuestionDto>> => {
    try {
      const response = await this.AxiosInstance.post('/parent/execution/instances/aiMode/nextQuestionAi', request);
      return response.data;
    } catch (error: any) {
      this.log.error("NextQuestionAi", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public CreateInstanceAi = async (data: {
    idSession: string;
    text?: string;
  }): Promise<ResponseMessage<{ instance: Instance }>> => {
    try {
      const response = await this.AxiosInstance.post(`/parent/execution/instances/aiMode/createInstance`, data);
      return response.data;
    } catch (error: any) {
      this.log.error("CreateInstanceAi", error.stack, JSON.stringify(error));
      throw error;
    }
  };

}